import { mdiShieldAccount } from '@mdi/js'

export default [
  {
    title: 'Menu.Acl',
    icon: mdiShieldAccount,
    resource: 'all',
    action: 'can_see_acl_menu',
    children: [
      {
        to: 'pages',
        title: 'Access.Pages.Menu',
        resource: 'all',
        action: 'can_see_and_edit_pages',
      },
      {
        to: 'permissions',
        title: 'Access.Permissions.Menu',
        resource: 'all',
        action: 'can_see_and_edit_permissions',
      },
      {
        to: 'roles',
        title: 'Access.Roles.Menu',
        resource: 'all',
        action: 'can_see_and_edit_roles',
      },
    ],
  },
]
